import React, { createContext } from "react";
import { MessageRestoreState } from "../hooks/useMessageRestoreState";

export interface MessageRestoreStateContextType {
  getRestoreState: (messageId: string) => MessageRestoreState;
}

export const MessageRestoreStateContext =
  createContext<MessageRestoreStateContextType | null>(null);

export const MessageRestoreStateProvider: React.FC<{
  children: React.ReactNode;
  getRestoreState: (messageId: string) => MessageRestoreState;
}> = ({ children, getRestoreState }) => {
  return (
    <MessageRestoreStateContext.Provider value={{ getRestoreState }}>
      {children}
    </MessageRestoreStateContext.Provider>
  );
};
